import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import lotusSvg from 'resources/svg/banner-element.svg'
import flowerSvg from 'resources/svg/blog-shape.svg'

export const Wrapper = styled.div`
  .box {
    background-color: ${props => props.theme.palette.primary.alphaMutted};
    color: ${props => props.theme.palette.general.light};
    padding: 15px 40px 20px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    margin-bottom: 30px;

    &:not(.perfect-product) {
      text-align: center;
      padding-bottom: 100px;

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: -80px;
        bottom: -100px;
        width: 100%;
        height: 100%;
        background: url(${lotusSvg}) no-repeat bottom left / 280px;
        z-index: -1;
      }
    }

    &.perfect-product {
      padding-top: 25px;

      h3 {
        margin: 5px 0 20px;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        right: -209px;
        top: -90px;
        width: 100%;
        height: 100%;
        background: url(${flowerSvg}) no-repeat top right / 280px;
        z-index: -1;
        transform: rotate(295deg);
        filter: brightness(0) invert(1);
      }
    }
  }

  h3 {
    font: ${font('alt', 'normal', '35px/1.2')};
    font-size: clamp(1.56rem, 2vw, 2.5rem);
    ${bp('sm')`
      font-size: 25px;
    `}
  }

  p {
    font: ${font('default', 'normal', '18px/1.2')};
    ${bp('sm')`
      font-size: 16px;
    `}
  }

  .btn,
  button {
    display: inline-block;
    text-decoration: none;
    font: ${font('alt', 'normal', '24px/1.2')};
    font-size: clamp(1.125rem, 2.2vw, 1.5rem);
    color: ${props => props.theme.palette.general.strong};
    padding: 10px 24px;
    background-color: ${props => props.theme.palette.general.light};
    border-color: ${props => props.theme.palette.general.light};
    border-radius: 3px;
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

    &:hover {
      box-shadow: 0 10px 18px rgba(0, 0, 0, 0.15), 0 9px 9px rgba(0, 0, 0, 0.12);
    }

    ${bp('sm')`
      font-size: 18px;
    `}

    > div {
      padding: 0;
    }
  }

  input {
    text-align: center;

    &::placeholder {
      color: ${props => props.theme.palette.general.strong};
    }
  }

  img {
    margin: 0 !important;
  }
`
